import ToggleButtonGroup, { ToggleOption } from "../../../../components/Forms/Buttons/ToggleButtonGroup";
import SearchInputField from "../../../../components/Forms/Input/SearchInputField";
import SelectField from "../../../../components/Forms/Input/SelectField";

export type RawMaterialActiveFilter = 'ALL' | 'ACTIVE' | 'INACTIVE';

interface RawMaterialOption {
  id: number;
  name: string;
}

interface RawMaterialFiltersProps {
  search: string;
  categoryId: number;
  unitId: number;
  supplierId: number;
  activeFilter: RawMaterialActiveFilter;
  categories: RawMaterialOption[];
  units: RawMaterialOption[];
  suppliers: RawMaterialOption[];
  onSearchChange: (value: string) => void;
  onCategoryChange: (categoryId: number) => void;
  onUnitChange: (unitId: number) => void;
  onSupplierChange: (supplierId: number) => void;
  onActiveChange: (activeFilter: RawMaterialActiveFilter) => void;
}

const activeOptions = [
  { value: 'ALL', label: 'Todas' },
  { value: 'ACTIVE', label: 'Activas' },
  { value: 'INACTIVE', label: 'Inactivas' },
] satisfies ToggleOption<RawMaterialActiveFilter>[];

const RawMaterialFilters = ({
  search,
  categoryId,
  unitId,
  supplierId,
  activeFilter,
  categories,
  units,
  suppliers,
  onSearchChange,
  onCategoryChange,
  onUnitChange,
  onSupplierChange,
  onActiveChange,
}: RawMaterialFiltersProps) => (
  <div className="grid grid-cols-1 gap-4 border-b border-stroke bg-gray-2/40 p-5 dark:border-strokedark dark:bg-boxdark-2/30 md:grid-cols-2 xl:grid-cols-[minmax(260px,1fr)_repeat(3,minmax(180px,220px))_auto] xl:items-end">
    <div className="xl:pb-5">
      <SearchInputField
        label="Buscar"
        name="rawMaterialSearch"
        value={search}
        iconKey="search"
        placeholder="Nombre, código o código de barras..."
        withMargin={false}
        onChange={(event) => onSearchChange(event.target.value)}
      />
    </div>

    <SelectField
      label="Categoría"
      name="rawMaterialCategoryFilter"
      value={categoryId}
      iconKey="category"
      options={[
        { value: 0, label: 'Todas las categorías' },
        ...categories.map((category) => ({
          value: category.id,
          label: category.name,
        })),
      ]}
      onChange={(event) => onCategoryChange(Number(event.target.value))}
    />

    <SelectField
      label="Unidad"
      name="rawMaterialUnitFilter"
      value={unitId}
      iconKey="box"
      options={[
        { value: 0, label: 'Todas las unidades' },
        ...units.map((unit) => ({
          value: unit.id,
          label: unit.name,
        })),
      ]}
      onChange={(event) => onUnitChange(Number(event.target.value))}
    />

    <SelectField
      label="Proveedor"
      name="rawMaterialSupplierFilter"
      value={supplierId}
      iconKey="user"
      options={[
        { value: 0, label: 'Todos los proveedores' },
        ...suppliers.map((supplier) => ({
          value: supplier.id,
          label: supplier.name,
        })),
      ]}
      onChange={(event) => onSupplierChange(Number(event.target.value))}
    />

    <ToggleButtonGroup
      value={activeFilter}
      options={activeOptions}
      onChange={onActiveChange}
      className="mb-5"
    />
  </div>
);

export default RawMaterialFilters;
